import React from 'react'
import { Link } from 'react-router-dom'

import {
  formatDateTime,
  globalStatuses,
  getTimezoneDate,
} from '../../../../utilities/helpers'

import Card from 'react-bootstrap/Card'
import Form from 'react-bootstrap/Form'
import Stack from 'react-bootstrap/Stack'
import Badge from 'react-bootstrap/Badge'

import { TrashButton } from '../../../TrashButton'

import placeholder from '../../../../assets/placeholder.png'

export default function Event({
  event,
  openDeleteModal,
  selected,
  onToggle,
  disabled,
}) {
  const timezone = event?.timezone
  const categoryLabel = [event?.category, ...(event?.subCategories || [])]
    .filter(Boolean)
    .join(' · ')

  const getStatus = (s) => {
    let status = s
    if (event?.status === 'unpublished') {
      status = 'draft'
    }
    // if is hidden and has not ended
    else if (!event?.isVisible && event?.status !== 'complete') {
      status = 'hidden'
    }

    // if sold out and has not ended
    else if (event?.isSoldOut && event?.status !== 'complete') {
      status = 'sold_out'
    }
    return globalStatuses[status]
  }

  return (
    <Card className="card--sm">
      <Card.Body className="flex gap-3">
        {onToggle ? (
          <Form.Check
            type="checkbox"
            className="align-self-center"
            aria-label={`Select ${event?.eventName || 'event'}`}
            checked={Boolean(selected)}
            disabled={disabled}
            onChange={() => onToggle(event)}
          />
        ) : null}
        <Link to={`/event/${event?.eventUUID}`} className="flex-grow-1">
          <Stack direction="horizontal" gap={3}>
            <Card.Img
              src={event?.eventImage || placeholder}
              width="80"
              height="80"
              className="event-image card-img-sm"
              alt={`Cover art for ${event?.eventName} event`}
            />
            <Stack className="justify-content-around">
              <Card.Title as="h5">{event?.eventName}</Card.Title>
              <Card.Subtitle
                as="h6"
                className="m-0 subtitle-bolder subtitle--dark"
              >
                {event?.venueName}
              </Card.Subtitle>
              <Card.Text className="text-muted small">
                <span>
                  <span>
                    {formatDateTime(
                      getTimezoneDate(event.eventDate, timezone),
                      'dateOnly'
                    )}
                  </span>
                  <span className="time">
                    {formatDateTime(
                      getTimezoneDate(event.eventDate, timezone),
                      'timeOnly'
                    )}
                  </span>
                </span>
              </Card.Text>
              {categoryLabel && (
                <Card.Text className="text-muted small mb-0">
                  {categoryLabel}
                </Card.Text>
              )}
            </Stack>
          </Stack>
        </Link>
        <Stack direction="horizontal" gap={3} className="ms-auto">
          <Badge
            bg="none"
            className={`badge--${getStatus(event?.status)?.type}`}
          >
            {getStatus(event?.status)?.label}
          </Badge>
          <TrashButton
            variant="danger"
            onClick={(e) => openDeleteModal(e, event?.eventUUID)}
          />
        </Stack>
      </Card.Body>
    </Card>
  )
}
